/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import { createContext, Dispatch, SetStateAction } from 'react';

export interface IApplicationContext {
  appId?: string;
  appName?: string;
  selectedNamespace?: string;
  setSelectedNamespace?: Dispatch<SetStateAction<string>>;
}

export const ApplicationContext = createContext({} as IApplicationContext);
